import React, { useState } from "react";
import localization from "assets/localization/localization";
import DatePicker from "components/sales/datePicker/datePicker";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
// import DropDownInput from "../Input/dropDownInput/dropDownInput";

const MasterAttendanceFilter = ({
  applyFilter,
  // getDropdownDatas,
  // activeInactive,
  // userList,
  setSelectedUser
}) => {

const savedFilter = JSON.parse(window.localStorage.getItem("all_valet_list_filter") || "{}");

const [filterFieldsData, setFilterFieldsData] = useState({
  start_date: savedFilter?.start_date || "",
  end_date: savedFilter?.end_date || "",
  user_id: savedFilter?.user_id || "",
});

// console.log(filterFieldsData);
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        window.localStorage.setItem("all_valet_list_filter", JSON.stringify(filterFieldsData));
        applyFilter(filterFieldsData);
      }}
    >
    {/* <DropDownInput
        label={localization.userName}
        data={userList}
        getValueById={
          window.localStorage?.all_valet_list_filter &&
          window.localStorage?.all_valet_list_filter
            ? JSON.parse(window.localStorage?.all_valet_list_filter)[
                "user_id"
              ]
            : ""
        }
        getIdValue={(val) => {
          setFilterFieldsData({
              ...filterFieldsData,
            user_id: val?.id
          });
          setSelectedUser(val?.id)
        }}
    /> */}
    <ConstantInput
        label='User ID'
        type='number'
        isStarRequired={true}
        value={
          window.localStorage?.all_valet_list_filter &&
          window.localStorage?.all_valet_list_filter
            ? JSON.parse(window.localStorage?.all_valet_list_filter)[
                "user_id"
              ]
            : ""
        }
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            user_id: val,
          });
          setSelectedUser(val);
        }}
      />
      <DatePicker
        label={localization.fromDate}
        returnFormat={'YYYY-MM-DD'}
        isStarRequired={true}
        value={
          window.localStorage?.all_valet_list_filter &&
          window.localStorage?.all_valet_list_filter
            ? JSON.parse(window.localStorage?.all_valet_list_filter)[
                "start_date"
              ]
            : ""
        }
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            start_date: val,
          });
        }}
        required={false}
      />
      <DatePicker
        label={localization.toDate}
        returnFormat={'YYYY-MM-DD'}
        isStarRequired={true}
        value={
          window.localStorage?.all_valet_list_filter &&
          window.localStorage?.all_valet_list_filter
            ? JSON.parse(window.localStorage?.all_valet_list_filter)[
                "end_date"
              ]
            : ""
        }
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            end_date: val,
          });
        }}
        required={false}
      />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setSelectedUser(null);
            window.localStorage.removeItem("all_valet_list_filter");
            window.location.reload()
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default MasterAttendanceFilter;